// frontend/src/services/ipfsUploader.ts
import axios from 'axios';

const pinataBaseURL = 'https://api.pinata.cloud/pinning';
// The PINATA_JWT is now an environment variable, accessed via process.env
// It's crucial this is not hardcoded in the repository.
const PINATA_JWT = process.env.REACT_APP_PINATA_JWT;

export const uploadFileToIPFS = async (file: File): Promise<string> => {

    if (!PINATA_JWT) {
        throw new Error('Pinata JWT is not configured. Please set REACT_APP_PINATA_JWT in your .env file.');
    }

    const url = `${pinataBaseURL}/pinFileToIPFS`;
    let data = new FormData();
    data.append('file', file);

    // Pinata options and metadata can be added if needed
    // data.append('pinataOptions', JSON.stringify({ cidVersion: 1 }));
    // data.append('pinataMetadata', JSON.stringify({ name: file.name }));

    const response = await axios.post(url, data, {
        maxBodyLength: Infinity, // Important for large files
        headers: {
            // 'Content-Type': `multipart/form-data; boundary=${data._boundary}`, // Axios handles this for FormData
            'Authorization': `Bearer ${PINATA_JWT}` // Use JWT Bearer token
        }
    });
    return response.data.IpfsHash;
};

export const uploadJsonToIPFS = async (jsonContent: object): Promise<string> => {
    if (!PINATA_JWT) {
        throw new Error('Pinata JWT is not configured. Please set REACT_APP_PINATA_JWT in your .env file.');
    }

    const url = `${pinataBaseURL}/pinJSONToIPFS`;

    // Pinata options and metadata can be added if needed
    // const payload = {
    //     pinataOptions: { cidVersion: 1 },
    //     pinataMetadata: { name: "metadata.json" }, // Or a more dynamic name
    //     pinataContent: jsonContent
    // };

    const response = await axios.post(url, jsonContent, { // Or 'payload' if using the above structure
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${PINATA_JWT}` // Use JWT Bearer token
        }
    });
    return response.data.IpfsHash;
};

// Example of how you might generate a JWT if you were doing it server-side
// (Not for frontend use directly with API Key/Secret)
// For frontend, you should obtain the JWT from Pinata's website directly.
// const generatePinataJWT = (apiKey: string, apiSecret: string) => {
//   // This is a simplified representation.
//   // JWT generation involves signing with the secret and is typically done on a backend.
//   // Pinata provides a way to generate a long-lived JWT from their dashboard.
//   console.warn("JWT generation logic is complex and should be handled securely, typically by obtaining it from Pinata's dashboard for frontend use.");
//   return "GENERATED_JWT_FROM_PINATA_DASHBOARD";
// };
